export default __webpack_public_path__ + "static/media/tg.fbafee72.svg";